import {metadaApi} from '@dms/api/base';

import {GetSettingsAuthorizationApiArg, GetSettingsAuthorizationApiResponse} from './types';

const metadaAuthorizationApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getSettingsAuthorization: build.query<
      GetSettingsAuthorizationApiResponse,
      GetSettingsAuthorizationApiArg
    >({
      query: () => ({
        url: `/core/v1/settings/authorization`,
      }),
    }),
  }),
});
export const {useGetSettingsAuthorizationQuery} = metadaAuthorizationApi;
